<template>
  <div v-if="user">
    <v-list-tile v-if="user">
      <v-list-tile-action> <v-icon>fas fa-user</v-icon> </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ user.name }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-if="user" @click.prevent="logout">
      <v-list-tile-action>
        <v-icon>fas fa-sign-out</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>Logout</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
<!--    <v-list-tile v-if="user" to="/favorites">-->
<!--      <v-list-tile-action>-->
<!--        <v-icon>fas fa-heart</v-icon>-->
<!--      </v-list-tile-action>-->
<!--      <v-list-tile-content>-->
<!--        <v-list-tile-title>Favorites</v-list-tile-title>-->
<!--      </v-list-tile-content>-->
<!--    </v-list-tile>-->
    <v-divider v-if="user"></v-divider>
  </div>
  <div v-else>
    <v-list-tile :to="{ name: 'login' }">
      <v-list-tile-action>
        <v-icon>fas fa-sign-in</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>User Login</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile href="/admin">
      <v-list-tile-action> <v-icon>fas fa-sign-in</v-icon> </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>Agent Login</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider></v-divider>
  </div>
</template>

<script>
import { logout } from '../api/auth';
import { mapMutations, mapGetters } from 'vuex';

export default {
  name: 'UserLinks',
  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },
  methods: {
    ...mapMutations(['showSnackbar', 'closeSnackbar']),
    logout() {
      this.$store.dispatch('logout');
      logout()
        .then((res) => {
          this.$store.commit('logoutSuccess', res);
          this.logoutSuccess();
        })
        .then(() => this.$router.push({ path: '/login' }))
        .catch((error) => {
          this.$store.commit('logoutFailed', { error });
          this.logoutFailed();
        });
    },
    logoutSuccess() {
      this.showSnackbar({
        text: 'You successfully logged out!',
        color: 'success',
        timeout: 3000,
      });
    },
    logoutFailed() {
      this.showSnackbar({
        text: 'There was a problem with logging out!',
        color: 'warning',
        timeout: 3000,
      });
    },
  },
};
</script>
